import { Box, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { consoleColors } from "../admin/consoleTheme";

export default function DrawTicketFailure() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const ticketId = params.get("ticket") || "";

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", background: consoleColors.page, px: 2 }}>
      <Box sx={{ width: "100%", maxWidth: 440, background: "#fff", border: `1px solid ${consoleColors.line}`, borderRadius: 3, p: 3, textAlign: "center" }}>
        <Typography sx={{ fontSize: 13, color: consoleColors.accent, fontWeight: 700, letterSpacing: 0.6 }}>CASHI</Typography>
        <Typography sx={{ fontSize: 28, fontWeight: 800, color: consoleColors.ink, mt: 1 }}>Payment was not completed</Typography>
        <Typography sx={{ color: consoleColors.muted, mt: 1.2 }}>Your Lucky Draw Ticket was not issued. You can try the payment again.</Typography>
        {ticketId && (
          <button type="button" onClick={() => navigate(`/drawticket/${ticketId}`)} style={{ marginTop: 22, minHeight: 48, padding: "0 18px", borderRadius: 12, border: 0, background: consoleColors.accent, color: "#fff", fontWeight: 800, fontSize: 16, cursor: "pointer" }}>
            Back to Lucky Draw Ticket
          </button>
        )}
      </Box>
    </Box>
  );
}
